//营销任务模块路由配置信息
export const salesTaskRouter = [
  {
    path: '/service/sales/marketing/task',
    name: 'MarketingTask',
    component: () => import('@/views/service/serviceProvider/salesTask/MarketingTask'),
    meta: {
      title: '营销任务',
      keepAlive: false
    }
  },
  {
    path: '/service/sales/marketing/task/creator',
    name: 'MarketingTaskCreator',
    component: () => import('@/views/service/serviceProvider/salesTask/MarketingTaskEditor'),
    meta: {
      title: '新增',
      keepAlive: false
    }
  },
  {
    path: '/service/sales/marketing/task/editor',
    name: 'MarketingTaskEditor',
    component: () => import('@/views/service/serviceProvider/salesTask/MarketingTaskEditor'),
    meta: {
      title: '编辑',
      keepAlive: false
    }
  },
  {
    path: '/service/sales/marketing/task/statistics',
    name: 'MarketingStatistics',
    component: () => import('@/views/service/serviceProvider/salesTask/MarketingStatistics'),
    meta: {
      title: '数据统计',
      keepAlive: false
    }
  },
  {
    path: '/service/sales/daily/attendance',
    name: 'DailyAttendance',
    component: () => import('@/views/service/serviceProvider/salesTask/DailyAttendance'),
    meta: {
      title: '打卡任务',
      keepAlive: false
    }
  },
  {
    path: '/service/sales/daily/attendance/statistics',
    name: 'DailyAttendanceStatistics',
    component: () => import('@/views/service/serviceProvider/salesTask/DailyAttendanceStatistics'),
    meta: {
      title: '数据统计',
      keepAlive: false
    }
  },
  {
    path: '/service/sales/withdrawal/setting',
    name: 'WithdrawalSettings',
    component: () => import('@/views/service/serviceProvider/salesTask/WithdrawalSettings'),
    meta: {
      title: '提现设置',
      keepAlive: false
    }
  }
]